import type { BinaryLabel, Setup } from "../types";
import { RevealBanner } from "./RevealBanner";
import { setupLineFor } from "./useSetupLine";

/**
 * The inline Reveal banner for Predict mode's weekly timeframe. Shows
 * correct/incorrect and the actual next-candle color (via RevealBanner).
 */

const COLOR_TEXT: Record<BinaryLabel, string> = { up: "Green", down: "Red" };

export type PredictWeeklyBannerProps = {
  guess: BinaryLabel;
  answer: BinaryLabel;
  note?: string;
  /** The Round's detected setup (GRA-141); absent on a pre-GRA-141 bank. */
  setup?: Setup;
  onNext: () => void;
};

export function PredictWeeklyBanner({
  guess,
  answer,
  note,
  setup,
  onNext,
}: PredictWeeklyBannerProps) {
  const correct = guess === answer;
  const setupLine = setupLineFor(setup);

  return (
    <RevealBanner
      note={note}
      setupLine={setupLine}
      onNext={onNext}
      verdict={
        <span className={correct ? "font-bold text-up" : "font-bold text-down"}>
          {correct ? "Correct" : "Wrong"}
        </span>
      }
    >
      <span className="text-muted">
        next candle was{" "}
        <span className={answer === "up" ? "text-up" : "text-down"}>{COLOR_TEXT[answer]}</span>
      </span>
    </RevealBanner>
  );
}
